import { useEffect } from "react";
import { useState } from "react";
import "./CustomModelInfoCard.scss";
import { ThermalModelInfoCard } from "./ThermalDesigner/components";

import {
  TrashIcon,
  EditIcon,
  ToggleButtonInactiveIcon,
  ToggleButtonActiveIcon,
  AddItemIconPlus,
  MiniDropdownIconOpened,
  MiniDropdownIconClosed,
  ReportIconRectangle,
  DividerLine,
} from "../SatelliteProfileImgAssets/SatelliteProfileImgAssets";

import { useParams } from "react-router-dom";
import MissionService from "../../../../../service/MissionService";
import { formatDecimal, showToastMessage } from "../../../../../utils/commonFunctions";

const SpikeModelInfoCard = ({
  reportProps,
  controlModeModalProps,
  controlModes,
  setPrevControlmode,
  setOpenDeleteDialouge,
  setCurrentControlMode,
  setIsModalMinimized,
  isModalMinimized,
  setHeaderObject,
  setIsValueUpdate,
}) => {
  const params = useParams();
  const { sat_name, sat_id } = params;

  const [isComponentInfoCardActive] = useState<boolean>(true);
  const [isMass] = useState(false);
  const [massInput, setMassInput] = useState({
    name: "Mass",
    isEnabled: isMass,
    value: 2,
    unit: "kg",
  });
  const [selectedControlModeObject, setSelectedControlModeObject] = useState();
  const [isControlModeObjectOpen, setIsControlModeObjectOpen] = useState(false);
  const [showEditDeleteDropdown, setShowEditDeleteDropdown] = useState(false);
  const [orientationValues, setOrientationValues] = useState<any>([]);
  const [orientationLabels, setOrientationLabels] = useState(["deg", "deg", "deg"]);
  const [moiXvalues, setMoiXValues] = useState<any>([]);
  const [moiXlabels, setMoiXLabels] = useState(["Ixx", "Ixy", "Ixz"]);
  const [moiYvalues, setMoiYValues] = useState<any>([]);
  const [moiYlabels, setMoiYLabels] = useState(["Iyy", "Iyz", "Izz"]);

  // const InfoCardReportActions = () => (
  //   <div className="infoCardReportActionsDiv">
  //     <div>
  //       <CopyIcon />
  //     </div>
  //     <div>
  //       <ReplaceIcon />
  //     </div>
  //     <div>
  //       <EditIcon />
  //     </div>
  //     <div>
  //       <TrashIcon />
  //     </div>
  //   </div>
  // );

  useEffect(() => {
    const overlayClose = () => {
      setShowEditDeleteDropdown(false);
    };
    window.addEventListener("click", overlayClose);
    return () => {
      window.removeEventListener("click", overlayClose);
    };
  }, []);

  useEffect(() => {
    MissionService.getMoi(sat_id)
      ?.then((res) => {
        if (res?.data) {
          const values = {
            mass: res?.data?.mass,
            orientation: res?.data?.orientation,
            moi: res?.data?.moi,
          };
          setOrientationValues(values?.orientation);
          setMoiXValues([values?.moi?.Ixx, values?.moi?.Ixy, values?.moi?.Ixz]);
          setMoiYValues([values?.moi?.Iyy, values?.moi?.Iyz, values?.moi?.Izz]);
          setMassInput({
            name: "Mass",
            isEnabled: isMass,
            value: values?.mass,
            unit: "kg",
          });
        }
      })
      .catch((err) => {
        showToastMessage("error", "Error while fetching the moi");
      });
  }, []);

  const SingleInputItem = ({ inputObject }) => (
    <>
      <div className="infocard-component-properties-div">
        <div className="infocard-component-properties-sub-div">
          <span className="infocard-units-location-span">{inputObject.name}</span>
          <div className="infocard-units-location-sub-div">
            {inputObject.isEnabledFunction && (
              <button onClick={() => inputObject?.isEnabledFunction(!inputObject?.isEnabled)}>
                {inputObject?.isEnabled ? <ToggleButtonActiveIcon /> : <ToggleButtonInactiveIcon />}
              </button>
            )}
            <div className="infocard-component-togglebtn-div" style={inputObject?.isEnabled ? {} : { pointerEvents: "none" }}>
              <div className="infocard-component-value-div mass-value">
                <span className="infocard-location-value">{inputObject?.orientation?.join(", ")}</span>
                <span className="infocard-location-value disabled">{inputObject?.value}</span>
              </div>
              <div className="infocard-component-units-div">
                <span className="infocard-location-y-axis">{inputObject?.unit}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  const SingleInputDropdownItem = ({ inputObject }) => (
    <div style={{ width: "100%" }}>
      <div className={selectedControlModeObject === inputObject ? "infocard-component-properties-div div-border active" : "infocard-component-properties-div div-border"}>
        <div className="infocard-component-properties-sub-div">
          <div className="infocard-cm-name w-45">
            <button
              className="infocard-component-properties-sub-div-dropdown"
              onClick={() => {
                setSelectedControlModeObject(inputObject);
                const isSameObject = selectedControlModeObject && (inputObject as { name: string }).name === (selectedControlModeObject as { name: string })?.name;
                if (isSameObject) {
                  // Toggle visibility if same object is clicked
                  setIsControlModeObjectOpen((prev) => !prev);
                } else {
                  // Always open if a different object is selected
                  setIsControlModeObjectOpen(true);
                  setSelectedControlModeObject(inputObject);
                }
              }}
            >
              {selectedControlModeObject === inputObject && isControlModeObjectOpen ? <MiniDropdownIconOpened /> : <MiniDropdownIconClosed />}
            </button>
            <span className="infocard-units-location-span" title={inputObject?.name}>
              {inputObject?.name}
            </span>
          </div>
          <div className="d-flex w-50 justify-content-end p-0">
            <div
              className="infocard-units-location-sub-div control-modes w-auto p-0"
              style={inputObject.name === "Nadir Pointing" || inputObject.name === "Sun Pointing" ? { paddingRight: "20px" } : {}}
            >
              <div className="infocard-component-togglebtn-div noBorder">
                <div className="infocard-component-value-div">
                  <span className="infocard-location-value">
                    {inputObject?.attitude ? (
                      inputObject?.orientation?.join(", ")
                    ) : (
                      <>
                        Sun | <span style={{ color: "#f33" }}>X&nbsp;</span> {inputObject?.orientation[0]}, <span style={{ color: "#ccf54e" }}>Y&nbsp;</span>{" "}
                        {inputObject?.orientation[1]}, <span style={{ color: "#9acef8" }}>Z&nbsp;</span> {inputObject?.orientation[2]}
                      </>
                    )}
                  </span>
                  <span className={`infocard-location-y-axis ${inputObject.attitude && "pe-1"}`}>
                    {inputObject.attitude ? <>{inputObject?.unit ? inputObject.unit : "deg"}</> : <></>}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex position-relative w-5 d-flex align-items-center justify-content-center">
            {inputObject.name !== "Nadir Pointing" && inputObject.name !== "Sun Pointing" && (
              <>
                <div className={`cm-edit-delete-container ${showEditDeleteDropdown === inputObject?.name && "active"}`}>
                  <button
                    className="dropdown__list__item"
                    onClick={() => {
                      setPrevControlmode(inputObject);
                      controlModeModalProps.setIsAddControlModeModal(true);
                      setHeaderObject((prev) => ({
                        ...prev,
                        title: "Edit Control Mode",
                      }));
                      if (isModalMinimized) {
                        setIsModalMinimized(false);
                      }
                      setIsValueUpdate(false);
                    }}
                  >
                    <EditIcon />
                    Edit
                  </button>
                  <button
                    className="dropdown__list__item"
                    onClick={() => {
                      setCurrentControlMode(inputObject?.name);
                      setOpenDeleteDialouge(true);
                    }}
                  >
                    <TrashIcon />
                    Delete
                  </button>
                </div>
                <button
                  className="bg-transparent border-0 h-auto w-auto p-0"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowEditDeleteDropdown((prev) => (prev === inputObject?.name ? false : inputObject?.name));
                  }}
                >
                  <i className="fe fe-more-vertical" />
                </button>
              </>
            )}
          </div>
        </div>
      </div>
      {/* details div */}
      {selectedControlModeObject === inputObject && isControlModeObjectOpen && (
        <div className="infocard-component-properties-div-dropdown-content">
          {!inputObject?.attitude && (
            <>
              <div className="infocard-component-properties-div-dropdown-item">
                <span>Pointing Entity</span>
                <span>Sun</span>
              </div>
              <div className="infocard-component-properties-div-dropdown-item">
                <span>Pointing Vector</span>
                <span>
                  Sun | <span style={{ color: "#f33" }}>X&nbsp;</span> {inputObject?.orientation[0]}, <span style={{ color: "#ccf54e" }}>Y&nbsp;</span>{" "}
                  {inputObject?.orientation[1]}, <span style={{ color: "#9acef8" }}>Z&nbsp;</span> {inputObject?.orientation[2]}
                </span>
              </div>
            </>
          )}
          {inputObject?.attitude && (
            <>
              <div className="infocard-component-properties-div-dropdown-item">
                <span>Roll</span>
                <span>
                  {inputObject?.orientation[0]}
                  <span>&nbsp;&nbsp;deg</span>
                </span>
              </div>
              <div className="infocard-component-properties-div-dropdown-item">
                <span>Pitch</span>
                <span>
                  {inputObject?.orientation[1]}
                  <span>&nbsp;&nbsp;deg</span>
                </span>
              </div>
              <div className="infocard-component-properties-div-dropdown-item">
                <span>Yaw</span>
                <span>
                  {inputObject?.orientation[2]}
                  <span>&nbsp;&nbsp;deg</span>
                </span>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );

  const ThreeInputItems = ({ values, labels, labelOrientation }) => (
    <div className="infocard-three-inputs-div">
      {values.map((value, index) => (
        <div className={labelOrientation ? "infocard-location-div orientation" : "infocard-location-div infocard-location-div-reverse"}>
          <div className="infocard-location-value-div">
            <input className="infocard-location-value-orientation text-truncate disabled" type="number" value={formatDecimal(value, 11)} title={formatDecimal(value, 11)}></input>
          </div>
          <div className="infocard-location-x-axis-div">
            {/* <span className={`${index === 0 ? (labelOrientation === 2 ? 'infocard-location-y-axis' : "infocard-location-x-axis") : ""} ${index === 1 ? (labelOrientation === 2 ? 'infocard-location-y-axis' : "infocard-location-y-axis") : ""} ${index === 2 ? (labelOrientation === 2 ? 'infocard-location-y-axis' : "infocard-location-z-axis") : ""}`}>
              {labels[index]}
            </span> */}
            <span className="infocard-location-y-axis">{labels[index]}</span>
          </div>
        </div>
      ))}
    </div>
  );

  

  return (
    <div className={`custom-model-infocard ${isComponentInfoCardActive ? "active" : ""} ${reportProps?.isReportBarOpen ? "isReportOpen" : ""}`} id="create_model_infocard">
      <div className="infocard-label-div">
        <span className="infocard-component-label">{sat_name}</span>
        {/* <InfoCardReportActions /> */}
      </div>
      <div className="infocard-properties-div">
        <div className="infocard-component-properties-div">
          <SingleInputItem inputObject={massInput} />

          {/* If label Orientation is 0, its left aligned, if 1 it is right aligned */}
          <div className="infocard-units-location-value-div">
            <span className="infocard-units-location-span">Orientation</span>
            {orientationValues.length > 0 && <ThreeInputItems values={orientationValues} labels={orientationLabels} labelOrientation={1} />}
          </div>

          <div className="infocard-units-location-value-div">
            <span className="infocard-units-location-span">MOI</span>
            {moiXvalues?.length > 0 && <ThreeInputItems values={moiXvalues} labels={moiXlabels} labelOrientation={2} />}
          </div>

          <div className="infocard-units-location-value-div">
            <span className="infocard-units-location-span"></span>
            {moiYlabels?.length > 0 && <ThreeInputItems values={moiYvalues} labels={moiYlabels} labelOrientation={2} />}
          </div>
        </div>
      </div>
      <DividerLine />
      <div className="infocard-label-div smaller">
        <span className="infocard-component-label">CONTROL MODE</span>
        <div
          className="scalingButton"
          onClick={() => {
            setPrevControlmode(null);
            controlModeModalProps.setIsAddControlModeModal(true);
            setHeaderObject((prev) => ({
              ...prev,
              title: "Add Control Mode",
            }));
            if (isModalMinimized) {
              setIsModalMinimized(false);
            }
          }}
        >
          <AddItemIconPlus />
        </div>
      </div>
      <div className="infocard-properties-div">{controlModes && controlModes?.map((controlMode) => <SingleInputDropdownItem inputObject={controlMode} />)}</div>
      <DividerLine />

      <ThermalModelInfoCard />

      <div className="report_icon_wrapper">
        <ReportIconRectangle />
      </div>

    </div>
  );
};

export default SpikeModelInfoCard;